// extracted by mini-css-extract-plugin
export default {"wrapper_0":"tPvqE4YQ","wrapper_1":"Ew9O17Zh","img_0":"NFyvZC7D","img_1":"pRVcLGpp"};